import * as apiUtils from '.'

// Hand-written mirror of the Zod output schema of
// GET /api/v1/admin/site-forecast-visibility; the generated OpenAPI spec is
// the contract source of truth if they ever disagree. `siteId` is a plain
// number here (not the branded SiteId) because the admin list/toggle round
// trip never carries a domain Site object -- it operates on the raw id
// returned by this report.
// bc#4122 -- which model produced/serves this site's forecast.
//
// Resolution order the server applies (packages/api-lib/src/lines/
// siteModelDisplay.ts): provenance from the cache object beats the current
// routing label, which beats "no model routed"/"lookup failed". The two
// no-answer states are DELIBERATELY distinct -- an S3 outage must never
// render the same as "this site genuinely has no model assigned".
export type SiteModelDisplaySource =
  | 'provenance'
  | 'routing'
  | 'none'
  | 'unavailable'

export interface SiteModelDisplay {
  source: SiteModelDisplaySource
  modelSlug: string | null
  label: string | null
  // Only ever populated for source:'provenance' -- the routing fallback has
  // no version, only a currently-assigned slug.
  artifactVersion: string | null
}

export interface SiteForecastVisibilityRow {
  siteId: number
  siteName: string | null
  projectId: number | null
  projectName: string | null
  organizationId: number | null
  organizationName: string | null
  showForecast: boolean
  lastForecastedAt: string | null
  modelDisplay: SiteModelDisplay
}

export interface SiteForecastVisibilityReport {
  sites: SiteForecastVisibilityRow[]
  // false when the S3 forecast-cache index couldn't be built (bucket
  // unconfigured or a listing threw): the list below is unfiltered and every
  // row's lastForecastedAt is null. See docs/specs/2026-07-09-site-visibility-
  // last-forecasted.md D4.
  forecastIndexAvailable: boolean
}

export const getAdminReport = (): Promise<SiteForecastVisibilityReport> =>
  apiUtils.GET('/admin/site-forecast-visibility')

export const setShowForecast = (
  siteId: number,
  showForecast: boolean,
): Promise<{ siteId: number; showForecast: boolean }> =>
  apiUtils.PUT(`/admin/site-forecast-visibility/${siteId}`, { showForecast })
